import React, { useEffect, useState } from 'react'
import Login from './login';
import Register  from './register';
export default function Authentication(props){


    return(
        <div class={`row`}>
            <div class={`col-md-6`}>
                <Login/>
            </div>
            <div class={`col-md-6`}>
                <Register />
            </div>
        </div>
        
    )
}